import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import notify from 'devextreme/ui/notify';
import { Title } from '@angular/platform-browser';
import { UserFacade } from 'src/app/store/user/facade';
import { UserModel } from 'src/app/store/user/model';
import { AbstractSelfDiagnosisApiService } from 'src/app/core/services/abstract/abstract-self-diagnosis-api-service';
import { SelfDiagnosisStepRateModel } from 'src/app/store/self-diagnostic/self-diagnosis/model';

@Component({
  selector: 'app-self-diagnostic-rate',
  templateUrl: './rate.component.html',
  styleUrls: ['./rate.component.scss'],
  host: {
    class: 'd-flex justify-content-center align-items-center h-100 w-100',
  },
  standalone: false,
})
export class RateComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  translate = inject(TranslateService);
  private selfDiagnosisApiService = inject(AbstractSelfDiagnosisApiService);
  private titleService = inject(Title);
  private userFacade = inject(UserFacade);

  private user: UserModel;

  private stepId: number;
  public rate: number = 0;

  public ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    // Get current language
    this.userFacade.selected().subscribe(user => {
      this.user = { ...user };
    });

    this.route.queryParamMap.subscribe(params => {
      this.stepId = +this.route.snapshot.queryParamMap.get('stepId');
    });
  }

  onClickMark(valueMark: number) {
    this.rate = valueMark;
  }

  public async callRate() {
    let rateModel = new SelfDiagnosisStepRateModel({
      selfDiagnosisStepId: this.stepId,
      employeeId: this.user.id,
      value: this.rate,
    });

    var response = await this.selfDiagnosisApiService.setStepRate(rateModel).toPromise();

    if (response.isSucceeded) {
      this.router.navigate(['/orders']);
    } else {
      notify({ message: response.errors[0], width: 600 }, 'error', 5000);
    }
  }
}
